<template>
	<div class="film_list">
      <div class="header_title" style="padding-left: 30px; margin-bottom: 0;">Каталог фильмов</div>
      <div v-for="(item, index) in paginatedItems" :key="item.id" :class="{ 'even-item': index % 2 === 0, 'odd-item': index % 2 !== 0 }" style="margin-bottom: 10px;">
					<div class="columns film_item">
              <div class="column afisha_column is-narrow">
                  <img class="afisha_img" :src="'https://cdn.moviestart.ru/uploads/images/'+item.afisha" alt="">
              </div>
              <div class="column film_item_right">

                  <div class="columns" style="margin-bottom: 0;">
                      <div class="column">
                          <div class="header_title">{{ item.name }}</div>
											</div>
                      <div class="column"><p class="podrobnee_film"><a class="button4" :href="'/company_film/'+item.id+'/md'" target="_blank">Подробнее о фильме</a></p></div>
                  </div>

                  <div class="countries_block">
                      <div class="columns">
                          <div class="column is-narrow">
                              <div class="columns">
                                  <div class="column" v-if="item.category">
                                      <p class="countries_block__title">Формат</p>
                                      <p class="countries_block__sub">{{ item.category }}</p>
                                  </div>
                                  <div v-if="item.zhanr" class="column is-narrow">
                                      <p class="countries_block__title">Жанр</p>
                                      <p class="countries_block__sub">{{ joinedKeys(item.zhanr) }}</p>
                                  </div>
                              </div>
                          </div>

                      </div>

                      <div class="columns">
                          <div class="column is-narrow" v-if="item.publishYear">
                              <div class="columns">
                                  <div class="column" >
                                      <p class="countries_block__title">Год выпуска</p>
                                      <p class="countries_block__sub">{{ item.publishYear }}</p>
                                  </div>
                              </div>
                          </div>
                          <div v-if="item.chronometr" class="column is-narrow">
                              <p class="countries_block__title">Хронометраж</p>
                              <p class="countries_block__sub">{{ item.chronometr }}</p>
                          </div>

                          <div v-if="item.project_data?.age_limit" class="column is-narrow">
                              <p class="countries_block__title">Возрастное ограничение</p>
                              <p class="countries_block__sub">{{ item.project_data.age_limit }}</p>
                          </div>
                      </div>

                      <div class="columns">
                          <div class="column" v-if="item.rezhiser">
                              <p class="countries_block__title">Полное ФИО режиссера</p>
                              <p class="countries_block__sub">{{ item.rezhiser }}</p>
                          </div>
                      </div>

                      <div class="columns"
                           v-if="item.project_data?.short_annotation">
                          <div class="column">
                              <p class="countries_block__title">Краткая аннотация</p>
                              <p class="countries_block__sub" v-html="item.project_data.short_annotation"></p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="columns" style="margin-top: 30px;">
              <div style="margin-top: -0.75rem;" class="column afisha_column is-narrow">
                  <div class="project_logo">
                      <img :src="'https://script.moviestart.ru/uploads/images/user/'+item.user.logo"
                           alt="">
                  </div>
							</div>
							<div class="column countries_block">
                  <div class="columns">
                      <div class="column">
                          <p v-if="item.production" class="countries_block__title">Производство</p>
                          <p v-if="item.production" class="countries_block__sub">{{
															item.production
                              }}</p>
											</div>
											<div class="column">
                          <p v-if="item.project_data?.production_country" class="countries_block__title">
                              Страна производства</p>
                          <p v-if="item.project_data?.production_country" class="countries_block__sub">
                              {{ item.project_data.production_country.join(',') }}</p>
											</div>
                      <div class="column">
                          <p style="text-align: right"><a class="button4" :href="'/film_company/'+item.user.id" target="_blank">Подробнее о компании</a></p>
                      </div>
                  </div>
							</div>
					</div>

			</div>

      <Pagination
              :current="current"
              :pageSize="pageSize"
              :total="films.length"
              @change="(page)=>{current = page;}"
      ></Pagination>

	</div>
</template>

<script setup>
import {ref, defineProps, toRefs, computed} from "vue";
import {Pagination} from "ant-design-vue"

let current = ref(1);
let pageSize = ref(10);

const props = defineProps({
	films: {}
})
const { films } = toRefs(props);

const paginatedItems = computed(() => {
  const start = (current.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return films.value.slice(start, end);
})

function joinedKeys(array) {
  if (array && Array.isArray(array)) {
    return array.join(', ')
  }
  return '';
}

</script>

<style scoped>
.field__wrapper {
    margin-bottom: 20px;
}

.field_label {
    font-weight: bold;
}

.countries_block {
    background: rgb(247, 247, 247);
    border-radius: 12px;
    display: inline-block;
    padding: 20px;
    padding-bottom: 0;
}

.countries_block > .columns > .column:not(:last-child) {
    margin-right: 30px;
}


.film_list .even-item {
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 30px;
    padding-bottom: 30px;
}
.film_list .odd-item {
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 30px;
    padding-bottom: 30px;
    background: #F7F7F7;
}
.film_list .odd-item .countries_block {
		background: #fff;
}

.afisha_column {
    margin-right: 20px;
}

.afisha_column img {
		max-width: 230px;
}

.countries_block {
    width: 100%;
}

.production_block {
    margin-top: 15px;
}

.project_logo {
		width: 30%;
}

.project_logo img {
    max-width: 125px;
}

.header_title {
    margin-bottom: 25px;
}

.countries_block .columns > .columns .column {
    padding: 0;
}

.countries_block > .columns {
    margin-bottom: 0;
}

hr {
		height: 1px;
		background: #000;
}
.film_item_right .header_title {
    margin-top: -10px;
    margin-bottom: 15px;
    font-size: 32px;
}
.afisha_img {
	border-radius: 12px;
}

.countries_block .button4 {
		background: #fff;
		color: #000;
		border: 1px solid #F7C100;
}
.ant-pagination {
		text-align: center;
}
.podrobnee_film {
    text-align: right;
		margin-bottom: 0;
}

@media (max-width: 1300px) {
    .column.is-narrow {
        flex: auto;
    }
}

@media (max-width: 770px) {
    .afisha_column {
        width: 100%;
    }
    .podrobnee_film {
				text-align: center;
		}
    .film_item_right .header_title {
        font-size: 26px;
				text-align: center;
        margin-bottom: 0;
		}
		.project_logo {
				margin: auto;
        margin-bottom: 20px;
		}
		.afisha_column {
				text-align: center;
		}
}

</style>